<script setup lang="ts">
import Skeleton from 'primevue/skeleton';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{ shape?: 'circle' | 'rectangle'; height?: 'md' | 'lg' | 'xl'; count?: number }>(),
  {
    shape: 'rectangle',
    height: 'md',
    count: 1
  }
);

const heights = {
  md: '1rem',
  lg: '2.5rem',
  xl: '4.5rem'
} as const;

const height = computed(() => heights[props.height]);
</script>

<template>
  <span class="tw-flex tw-w-full tw-flex-col tw-gap-2">
    <Skeleton v-for="i in count" :key="i" :shape="props.shape" :height />
  </span>
</template>
